(function () {
  'use strict';

  // ─── 常量 ─────────────────────────────────────────────────────────────────
  var MOBILE_BP  = 767;
  var ARROW_HALF = 8;
  var EDGE_PAD   = 16;

  // ─── 工具函数 ──────────────────────────────────────────────────────────────
  function isMobile() {
    return window.innerWidth <= MOBILE_BP;
  }

  // ─── Tooltip 定位 ──────────────────────────────────────────────────────────
  function positionTooltip(wrap) {
    var icon    = wrap.querySelector('.product-info-more-icon');
    var tooltip = wrap.querySelector('.product-info-more-tooltip');
    if (!icon || !tooltip) return;

    if (!isMobile()) {
      resetMobileStyles(tooltip);
      return;
    }

    var vw          = window.innerWidth;
    var wrapRect    = wrap.getBoundingClientRect();
    var iconRect    = icon.getBoundingClientRect();
    var tooltipW    = Math.min(vw - EDGE_PAD * 2, 420);

    tooltip.style.width      = tooltipW + 'px';
    tooltip.style.marginLeft = (vw / 2 - (wrapRect.left + wrapRect.width / 2)) + 'px';

    var tooltipLeftX = vw / 2 - tooltipW / 2;
    var arrowLeft    = (iconRect.left + iconRect.width / 2) - tooltipLeftX - ARROW_HALF;
    arrowLeft = Math.max(4, Math.min(tooltipW - ARROW_HALF * 2 - 4, arrowLeft));
    tooltip.style.setProperty('--tooltip-arrow-left', arrowLeft + 'px');
  }

  function resetMobileStyles(tooltip) {
    if (!tooltip) return;
    tooltip.style.width      = '';
    tooltip.style.marginLeft = '';
    tooltip.style.removeProperty('--tooltip-arrow-left');
  }

  function openWrap(wrap) {
    positionTooltip(wrap);
    wrap.classList.add('is-open');
  }

  function closeWrap(wrap) {
    wrap.classList.remove('is-open');
    resetMobileStyles(wrap.querySelector('.product-info-more-tooltip'));
  }

  // ─── Tooltip 点击交互初始化 ────────────────────────────────────────────────
  function initTooltip() {
    var wraps = Array.prototype.slice.call(document.querySelectorAll(
      '.product-info__member-discount .product-info-more-wrap'
    ));
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var icon = wrap.querySelector('.product-info-more-icon');
      if (!icon) return;

      icon.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = wrap.classList.contains('is-open');
        wraps.forEach(function (w) { if (w !== wrap) closeWrap(w); });
        isOpen ? closeWrap(wrap) : openWrap(wrap);
      });

      var tooltip = wrap.querySelector('.product-info-more-tooltip');
      if (tooltip) {
        tooltip.addEventListener('click', function (e) { e.stopPropagation(); });
      }
    });

    document.addEventListener('click', function () { wraps.forEach(closeWrap); });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        wraps.forEach(function (wrap) {
          resetMobileStyles(wrap.querySelector('.product-info-more-tooltip'));
        });
      }
    });
  }

  // ─── Member Discount Block：变体切换更新 ────────────────────────────────────
  function initMemberDiscount() {
    var blocks = document.querySelectorAll('.product-info__member-discount[data-section]');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var dataEl = block.querySelector('.js-member-price-data');
      if (!dataEl) return;

      var cfg;
      try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var isZeroDec = cfg.zeroDecimalCurrencies.indexOf(cfg.currencyIso) >= 0;

      function fmtMoney(cents) {
        var amount = isZeroDec ? cents : cents / 100;
        try {
          return new Intl.NumberFormat(cfg.shopLocale, {
            style: 'currency', currency: cfg.shopCurrency
          }).format(amount);
        } catch (e) {
          return (isZeroDec ? cents : (cents / 100).toFixed(2)) + ' ' + cfg.shopCurrency;
        }
      }

      function buildTooltipHtml(origCents, discCents, memCents) {
        var oh  = '<strong>' + fmtMoney(origCents) + '</strong>';
        var dh  = '<strong>' + fmtMoney(discCents) + '</strong>';
        var mh  = '<strong>' + fmtMoney(memCents)  + '</strong>';
        var tpl = cfg.discountTemplate || '';
        var html = tpl
          .replace(/\{\{?\s*original_price\s*\}?\}/g,  oh)
          .replace(/\{\{?\s*discount_amount\s*\}?\}/g, dh)
          .replace(/\{\{?\s*member_price\s*\}?\}/g,    mh)
          .replace(/\[original_price\]/g,  oh)
          .replace(/\[discount_amount\]/g, dh)
          .replace(/\[member_price\]/g,    mh);
        if (!html.includes(fmtMoney(origCents)) ||
            !html.includes(fmtMoney(discCents)) ||
            !html.includes(fmtMoney(memCents))) {
          html = oh + ' less ' + dh + ' member discount - You pay ' + mh;
        }
        return html;
      }

      document.addEventListener('on:variant:change', function (e) {
        if (!e.detail || !e.detail.variant) return;
        var variant = e.detail.variant;

        // 关闭已打开的 tooltip
        var wrap = block.querySelector('.product-info-more-wrap');
        if (wrap) wrap.classList.remove('is-open');

        var rawVal = cfg.variants[String(variant.id)];
        if (rawVal === null || rawVal === undefined) {
          block.hidden = true;
          return;
        }

        var memCents     = isZeroDec ? Math.round(rawVal) : Math.round(rawVal * 100);
        var varPrice     = variant.price || 0;
        // discount_amount (售价 - 会员价); Extra % 分母固定用售价（划线价不是每个产品都有）
        var discCents    = varPrice - memCents;

        var priceEl = block.querySelector('.product-info__member-price-display');
        if (priceEl) priceEl.textContent = cfg.memberPriceLabel + ': ' + fmtMoney(memCents);

        var pctEl = block.querySelector('.product-info__member-discount-text-percentage');
        if (pctEl) {
          if (cfg.discountType === 'percentage') {
            var pct = varPrice > 0 ? Math.round(discCents * 100 / varPrice) : 0;
            pctEl.textContent = '(' + cfg.extraPrefix + ' ' + pct + '% off)';
          } else {
            pctEl.textContent = '(' + cfg.extraPrefix + ' ' + fmtMoney(discCents) + ' off)';
          }
        }

        var tipEl = block.querySelector('.product-info-more-tooltip');
        if (tipEl) tipEl.innerHTML = buildTooltipHtml(varPrice, discCents, memCents);

        block.hidden = false;
      });
    });
  }

  // ─── Installment Accordion：分期支付折叠面板 ─────────────────────────────────
  function initInstallmentAccordion() {
    var containers = document.querySelectorAll('[data-installment-accordion]');
    if (!containers.length) return;

    containers.forEach(function(container) {
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      var toggle = container.querySelector('[data-installment-toggle]');
      var content = container.querySelector('[data-installment-content]');
      if (!toggle || !content) return;

      function hasInstallmentInfo() {
        var hasVisibleText = false;
        var nodes = content.querySelectorAll('klarna-placement, #paypal-price, .affirm-as-low-as, .rg-after-pay-wrap');
        nodes.forEach(function(node) {
          if (!node) return;
          var text = (node.textContent || '').replace(/\s+/g, '').trim();
          if (text.length > 0) hasVisibleText = true;
          if (node.querySelector && (node.querySelector('iframe') || node.querySelector('*'))) {
            var childrenCount = node.children ? node.children.length : 0;
            if (childrenCount > 0) hasVisibleText = true;
          }
        });
        return hasVisibleText;
      }

      function refreshVisibility() {
        if (hasInstallmentInfo()) {
          container.classList.remove('is-hidden');
        } else {
          container.classList.add('is-hidden');
        }
      }

      toggle.addEventListener('click', function() {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        content.hidden = expanded;
      });

      refreshVisibility();
      var observer = new MutationObserver(refreshVisibility);
      observer.observe(content, { childList: true, subtree: true, characterData: true });
    });
  }

  // ─── Key Features：内容超过约 6 行时显示「Learn more」展开（与条数无关） ─────
  function initFeatureKeyListExpand() {
    var wraps = document.querySelectorAll('[data-feature-key-list]');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      if (wrap.dataset.featureKeyInit === 'true') return;
      wrap.dataset.featureKeyInit = 'true';

      var btn = wrap.querySelector('[data-feature-key-toggle]');
      var ul = wrap.querySelector('.feature-key-list');
      if (!btn || !ul) return;

      var labelMore = btn.textContent.trim();
      var labelLess = (btn.dataset.labelLess || '').trim() || 'Show less';
      var resizeTimer = null;

      function measureOverflow() {
        var wasExpanded = wrap.classList.contains('is-expanded');
        wrap.classList.remove('is-expanded');
        wrap.classList.add('feature-key-list-wrap--collapsible');
        void ul.offsetHeight;
        var overflow = ul.scrollHeight > ul.clientHeight + 2;
        if (overflow) {
          btn.hidden = false;
          if (wasExpanded) {
            wrap.classList.add('is-expanded');
            btn.setAttribute('aria-expanded', 'true');
            btn.textContent = labelLess;
          } else {
            btn.setAttribute('aria-expanded', 'false');
            btn.textContent = labelMore;
          }
        } else {
          wrap.classList.remove('feature-key-list-wrap--collapsible');
          wrap.classList.remove('is-expanded');
          btn.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = labelMore;
        }
      }

      function scheduleMeasure() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(measureOverflow, 150);
      }

      btn.addEventListener('click', function () {
        if (btn.hidden) return;
        var expanded = wrap.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? labelLess : labelMore;
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          requestAnimationFrame(measureOverflow);
        });
      } else {
        requestAnimationFrame(function () {
          requestAnimationFrame(measureOverflow);
        });
      }

      window.addEventListener('resize', scheduleMeasure);
    });
  }

  // ─── 入口 ─────────────────────────────────────────────────────────────────
  function init() {
    initTooltip();
    initMemberDiscount();
    initInstallmentAccordion();
    initFeatureKeyListExpand();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
